import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CriSection from "../../components/CriSection";
import BeeHabitats, { BeeHabitatsType } from "../../constants/bee_habitats";
import { Key } from "react";

const Habitats = () => {
  return (
    <CriSection alternate={true}>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 300,
          lineHeight: 1,
          textAlign: "center",
        }}
      >
        Bee Habitats
      </Typography>

      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 300,
          lineHeight: 1.2,
          marginTop: "12px",
        }}
      >
        Throughout the region numerous species are found reliably in remnant
        habitat types, such as in gravel hill prairies and oak savannas, on
        their preferred plant hosts. One such example is Colletes andrewsi, a
        pollen specialist of Heuchera richardsonii or prairie alumroot. Native
        to the region, this prairie species is on the eastern edge of its
        geographic range. Locally, it is conservative to gravel hill prairies
        and wet to dry-mesic outwash prairies in Illinois and Wisconsin.
        Interesting is that, in Illinois, this bee associates with another
        alumroot specialist, Colletes aestivalis. As each portion of the region
        is studied, more bee species will be added, the fauna still incomplete.
      </Typography>

      <Grid
        container
        spacing={{ xs: 2, md: 4 }}
        sx={{
          marginTop: "36px",
        }}
      >
        {BeeHabitats.map(
          (habitat: BeeHabitatsType, index: Key | null | undefined) => (
            <Grid size={{ xs: 6, md: 4 }} key={index}>
              <Box>
                <img
                  src={habitat.image}
                  alt="Habitat"
                  style={{
                    width: "100%",
                    height: "200px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                <Typography
                  sx={{
                    marginTop: "6px",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  {habitat.description}
                </Typography>
              </Box>
            </Grid>
          )
        )}
      </Grid>
    </CriSection>
  );
};

export default Habitats;
